export const FETCH_FEATURE_FLAGS_REQUEST = 'FETCH_FEATURE_FLAGS_REQUEST';
export const FETCH_FEATURE_FLAGS_SUCCESS = 'FETCH_FEATURE_FLAGS_SUCCESS';
export const FETCH_FEATURE_FLAGS_FAIL = 'FETCH_FEATURE_FLAGS_FAIL';